(() => {
  if (window.HNFormProtection) return;
  const sitekey = document.currentScript.dataset.sitekey;
  let loading;
  const pending = new WeakMap();
  function loadTurnstile() {
    if (window.turnstile) return Promise.resolve(window.turnstile);
    if (loading) return loading;
    loading = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      const timer = setTimeout(() => fail(), 15000);
      const fail = () => {
        clearTimeout(timer); script.remove(); loading = null;
        reject(new Error('Verification is unavailable. Please try again.'));
      };
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      script.async = true;
      script.onload = () => { clearTimeout(timer); window.turnstile ? resolve(window.turnstile) : fail(); };
      script.onerror = fail;
      document.head.append(script);
    });
    return loading;
  }
  async function verify(form, action) {
    if (!form?.isConnected || !sitekey) throw new Error('Verification is unavailable. Please try again.');
    if (pending.has(form)) return pending.get(form);
    const request = (async () => {
      const api = await loadTurnstile();
      if (!form.isConnected) throw new Error('Form closed. Please try again.');
      return new Promise((resolve, reject) => {
        const container = document.createElement('div');
        container.className = 'hn-form-verification';
        form.append(container);
        let widget;
        let done = false;
        const finish = (token, message) => {
          if (done) return; done = true;
          clearTimeout(timer); observer.disconnect();
          if (widget !== undefined) api.remove(widget);
          container.remove();
          if (token) resolve(token);
          else { const error = new Error(message); error.formMessage = message; reject(error); }
        };
        const timer = setTimeout(() => finish(null, 'Verification took too long. Please try again.'), 120000);
        const observer = new MutationObserver(() => {
          if (!container.isConnected) finish(null, 'Form closed. Please try again.');
        });
        observer.observe(document.body, {childList:true, subtree:true});
        try {
          widget = api.render(container, {
            sitekey, action, appearance:'interaction-only', execution:'execute',
            theme:'auto', size:'flexible', 'response-field':false,
            callback: token => finish(token),
            'error-callback': () => { finish(null, 'Verification failed. Please try again.'); return true; },
            'expired-callback': () => finish(null, 'Verification expired. Please try again.'),
            'timeout-callback': () => finish(null, 'Verification took too long. Please try again.')
          });
          api.execute(widget);
        } catch { finish(null, 'Verification is unavailable. Please try again.'); }
      });
    })();
    pending.set(form, request);
    try { return await request; } finally { pending.delete(form); }
  }

  const messages = {
    invalid_email: 'Please check your email address for typos, spaces or repeated dots.',
    invalid_name: 'Please enter your first name.',
    verification_required: 'We could not verify this request. Please try again.',
    verification_unavailable: 'Verification is temporarily unavailable. Please try again shortly.',
    rate_limited: 'Too many requests. Please try again later.',
    recent_request: 'You recently requested this email. Please check your inbox and spam folder, or try again in 10 minutes.'
  };
  window.HNFormProtection = {
    message(code) { return messages[code] || ''; },
    verify,
    async prepareLead(payload, form) {
      const turnstile = await verify(form, payload.lead_intent);
      return {...payload, turnstile};
    }
  };
  const setup=(root=document)=>root.querySelectorAll('[data-newsletter-form]').forEach(form=>{
    if(form.dataset.ready)return;form.dataset.ready='true';
    const button=form.querySelector('[type=submit]'),status=form.querySelector('[role=status]');button.disabled=false;
    form.addEventListener('submit',async event=>{
      event.preventDefault();if(form.dataset.pending||!form.reportValidity())return;
      form.dataset.pending='true';button.disabled=true;const label=button.textContent;button.textContent='Joining…';status.textContent='';
      try{
        const endpoint=form.dataset.endpoint;
        const turnstile=await verify(form, 'newsletter');
        const response=await fetch(endpoint,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({...Object.fromEntries(new FormData(form)),turnstile,source:'footer'}),signal:AbortSignal.timeout(15000)});
        const result=await response.json();
        if(!response.ok||result.code!=='subscribed')throw new Error(result.code==='contact_support'?'Please contact customers@heartsnotes.com to update your subscription.':messages[result.code] || 'We couldn’t confirm your signup. Please try again.');
        status.textContent=form.dataset.successMessage||'You’re subscribed. Welcome to Hearts Notes!';
        const fields=form.querySelector('[data-newsletter-fields], .newsletter-form__field-wrapper');
        if(fields)fields.hidden=true;
      }catch(error){status.textContent=error.message||'Please try again.';}
      finally{delete form.dataset.pending;button.disabled=false;button.textContent=label;}
    });
  });
  setup();document.addEventListener('shopify:section:load',event=>setup(event.target));
})();
